import React from "react";
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import styles from "./Reason.module.scss";

function Reason({ reason, setReason }) {
  const handleModalClose = () => {
    setReason(false);
  };

  return (
    <Dialog open={reason} onClose={handleModalClose}>
      <DialogContent style={{ paddingBottom: "0" }}>
        <div className={styles.title}>Decline Quotation</div>

        <div className={styles.formContainer}>
          Has admin on duty call the hospital for clarification that we are working to get this resolved quickly?
        </div>
      </DialogContent>

      <DialogActions style={{ paddingRight: "49px", paddingBottom: "49px" }}>
        <div
          style={{
            cursor: "pointer",
            color: "#ffffff",
            backgroundColor: "#b70303",
            padding: "10px",
            borderRadius: "3px",
            border: "1px solid #DFE1E6",
            fontSize: "14px",
          }}
          onClick={handleModalClose}
        >
          Yes
        </div>
      </DialogActions>
    </Dialog>
  );
}

export default Reason;
